// extracted by mini-css-extract-plugin
export default {"commentForm":"commentForm_commentForm__Yo4vN","input":"commentForm_input__tq7gG","button":"commentForm_button__5zo3f"};